import TermsConditionsNewComponent from "../components/TermsConditions/TermsConditionsNewComponent";
import { connect } from "react-redux";

const mapDispatchToProps = {};

const mapStateToProps = state => {
  return {};
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(TermsConditionsNewComponent);
